<template>
  <div class="login-container">
    <el-form ref="formData" :model="formData" :rules="formRules">
      <div class="title">
        <h3>系统登录</h3>
      </div>

      <el-form-item prop="username">
        <el-input
          ref="username"
          placeholder="用户名/手机号"
          prefix-icon="el-icon-user-solid"
          v-model="formData.username"
        />
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          ref="password"
          placeholder="密码"
          show-password
          prefix-icon="el-icon-lock"
          v-model="formData.password"
          @keyup.enter.native="handleLogin"
        />
      </el-form-item>

      <el-button @click="handleLogin">登录</el-button>
    </el-form>
  </div>
</template>
<script>
export default {
  name: "Login",
  data() {
    return {
      formData: {
        username: "",
        password: "",
      },
      formRules: {
        username: [
          { required: true, trigger: "blur", message: "请输入用户名" },
        ],
        password: [{ required: true, trigger: "blur", message: "请输入密码" }],
      },
    };
  },
  // 54466|nuf9IJMRgvIXrcareVgB55v1Pq/VhP0aDbvB76Hnk0n+CAW3TTubGoPhGbcAnYCbWIoBIktfacJVTrElQaFbSA==
  // 54467|mm4Uxpz7BHDnPcGeYyQ+Ti1c+mGKhr1a3wIWDzBj3VSfgF+4Lg1EUodSXiyhzIDl7ieehcyZigwzo6+etXTKOQ==
  // 54471|4BbSvekSG4Iu4CLudUPfGQXiZtNrulskq6hygN/ZjHqF4gZu2I7bRW4UkTNtMTD9zciW4SudrR+ACd5PL6+eVQ==
  mounted() {
    if (this.formData.username === "") {
      this.$refs.username.focus();
    } else {
      this.$refs.password.focus();
    }
  },
  methods: {
    handleLogin() {
      // 为spbprod的登录接口保持一致，同时支持mobile和username字段
      const data = { 
        mobile: this.formData.username,
        username: this.formData.username,
        password: this.formData.password
      };
      this.$store.dispatch("user/login", data).then((res) => {
        if (res) {
          this.$router.push("/");
        }
      });
    },
  },
};
</script>
<style lang="less">
@supports (-webkit-mask: none) and (not (cater-color: #fff)) {
  .login-container .el-input input {
    color: #fff;
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;

    input {
      margin-left: 25px;
      width: calc(100% - 30px);
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: #fff;
      height: 47px;
      caret-color: #fff;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px #283443 inset !important;
        -webkit-text-fill-color: #fff !important;
      }
    }
  }

  .el-form-item {
    // border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>
<style lang="less" scoped>
.login-container {
  width: 100%;
  height: 100%;
  background-color: #2d3a4b;
  .el-form {
    box-sizing: inherit;
    margin: 0 auto;
    padding: 160px 35px 0;
    width: 520px;
    .title {
      h3 {
        margin: 0 0 40px;
        text-align: center;
        font-size: 26px;
        color: #eee;
      }
    }
    .el-form-item {
      width: 450px;
      height: 50px;
      .el-input {
        height: 50px;
        border: 1px solid #3f4957;
        background-color: #283443;
        border-radius: 4px;
        color: #f0f3ee;
      }
    }
    .el-button {
      width: 100%;
      height: 36px;
      color: #fff;
      background-color: #1890ff;
      border-color: #1890ff;
      &:hover {
        background: #46a6ff;
        border-color: #46a6ff;
        color: #fff;
      }
    }
  }
}
</style>